// The server is the source of truth and will reject anything missed here.
const PIN_BLOCKLIST = new Set<string>([
  '000000',
  '111111',
  '222222',
  '333333',
  '444444',
  '555555',
  '666666',
  '777777',
  '888888',
  '999999',
  '123456',
  '654321',
  '012345',
  '543210',
]);

export const PIN_LENGTH = 6;

/**
 * Validate a PIN against the same policy the server enforces.
 * Returns null when valid, or a user-facing error message when invalid.
 */
export const validatePinPolicy = (pin: string): string | null => {
  if (typeof pin !== 'string' || pin.length === 0) {
    return 'PIN is required';
  }
  if (!/^\d+$/.test(pin) || pin.length !== PIN_LENGTH) {
    return `PIN must be ${PIN_LENGTH} digits`;
  }
  if (PIN_BLOCKLIST.has(pin)) {
    return 'PIN is too common. Pick something less guessable.';
  }
  return null;
};
